import { type Component, Show } from "solid-js";

import type { PendingAttachment } from "./attachmentsStore";

export interface AttachmentChipProps {
  attachment: PendingAttachment;
  onRemove: (id: string) => void;
}

function formatBytes(n: number): string {
  if (n < 1024) return `${n}B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)}KB`;
  return `${(n / (1024 * 1024)).toFixed(1)}MB`;
}

const AttachmentChip: Component<AttachmentChipProps> = (props) => {
  const status = () => props.attachment.status;
  return (
    <span
      class="chat-attachment-chip"
      classList={{
        "is-uploading": status() === "uploading",
        "is-ready": status() === "ready",
        "is-failed": status() === "failed",
      }}
      title={props.attachment.error ?? props.attachment.filename}
    >
      <span class="chat-attachment-icon" aria-hidden="true">
        📎
      </span>
      <span class="chat-attachment-name">{props.attachment.filename}</span>
      <Show
        when={status() === "uploading"}
        fallback={
          <span class="chat-attachment-meta">
            <Show
              when={status() === "ready" && props.attachment.bytes > 0}
              fallback={
                <Show when={status() === "failed"}>
                  <em>failed</em>
                </Show>
              }
            >
              {formatBytes(props.attachment.bytes)}
            </Show>
          </span>
        }
      >
        <span class="chat-attachment-meta">uploading…</span>
      </Show>
      <button
        type="button"
        class="chat-attachment-remove"
        aria-label={`remove ${props.attachment.filename}`}
        onClick={() => props.onRemove(props.attachment.id)}
      >
        ×
      </button>
    </span>
  );
};

export default AttachmentChip;
